<app-title
  [title]="title"
  [subtitle]="stepData.subtitle"
  [description]="campaign.description"
>
  @if(step > -1) {
  <div class="row py-3 gx-2 align-items-center justify-content-end">
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-secondary px-4" (click)="back()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
    </div>
    @for (item of stepData.actions; track $index) {
    <!--  -->
    <div class="col-auto">
      @if (item === 'PUBLISH') {
      <div class="d-inline-block mx-3">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="published"
            [(ngModel)]="data.published"
            (ngModelChange)="handleAction($index)"
          />

          <label class="form-check-label" for="published">Published</label>
        </div>
      </div>
      <!--  -->
      } @else {
      <button
        type="button"
        class="btn ms-2"
        [ngClass]="$index % 2 === 0 ? 'btn-primary' : 'btn-secondary'"
        (click)="handleAction($index)"
      >
        {{ item }}
      </button>
      }
      <!--  -->
    </div>
    }
  </div>
  }
</app-title>

<div class="container px-0">
  @if (initialized()) {
  <div class="row py-3 py-lg-4 py-xl-5">
    <div class="col-12 px-0">
      @switch (step) {
      <!-- FIELDBOARDS ID = 1 -->
      @case (1) {
      <app-fieldboards
        #fieldboards
        [data]="segmentData.fieldboard"
        [typeId]="segmentId"
        [viewership]="campaign['viewership']"
      ></app-fieldboards>
      <!--  -->
      }
      <!-- KEY MOMENTS ID = 2 -->
      @case (2) {
      <app-fieldboards
        #keyMoments
        [data]="segmentData.keyMoments"
        [typeId]="segmentId"
        [viewership]="campaign['viewership']"
      ></app-fieldboards>
      <!--  -->
      }
      <!-- NEAR GOAL ID = 3 -->
      @case (3) {
      <app-near-goal
        #nearGoal
        [data]="segmentData.nearGoal"
        [typeId]="segmentId"
        [viewership]="campaign['viewership']"
      ></app-near-goal>
      <!--  -->
      }
      <!-- EARNED MEDIA ID = 4 -->
      @case (4) {
      <app-earned-media
        #earnedMedia
        [data]="segmentData.earnedMedia"
        [typeId]="segmentId"
      ></app-earned-media>
      <!--  -->
      }
      <!-- HOME SCREEN -->
      @default {
      <!--  -->
      @if (campaign.id !== -1) {
      <app-monthly-summary
        [data]="data"
        (onStepChange)="handleType($event)"
      ></app-monthly-summary>
      }
      <!-- HOME SCREEN -->
      }
      <!--  -->
      }
    </div>
  </div>
  }
</div>
